// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-148b4fc6]{display:inline-block;padding-left:.2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
